import '~/init'
import '~/controllers'
import TurboPower from 'turbo_power'
import * as Turbo from '@hotwired/turbo'

import 'flowbite/dist/flowbite.turbo.js'
TurboPower.initialize(Turbo.StreamActions)

// Import JS and CSS from view_components
import.meta.glob('../../components/**/*.js', { eager: true })
import.meta.glob('../../components/**/*.css', { eager: true })
